
const voucherwork = (props, location, navigate, confirm, showsnackbar, setUdak, setDowait, setVchroptions) => {
/*
test with PERSON_ID=30901 Rodney  Francois lbr_clr_app_id 2
DELETE FROM LBR_CLR_APP_DECISION WHERE LBR_CLR_APP_ID=2;
UPDATE LBR_CLR_APP SET APP_STATUS_ID=5 WHERE LBR_CLR_APP_ID=2;
SELECT *  FROM [Immigration].[dbo].[IMG_APP_DECISION]  WHERE CONVERT(CHAR(10), updated_date, 120) = CONVERT(CHAR(10), GETDATE(), 120)
DELETE FROM [Immigration].[dbo].[IMG_APP_DECISION] WHERE lbr_clr_app_id=2;


DELETE FROM WPT_APP_UDAK WHERE TRUNC(CREATE_DATE)>='14-MAY-26' OR TRUNC(NVL(DOC_NO_DATE, '13-MAY-26'))>='14-MAY-26';
DELETE FROM PREP_INSERT_DOCUMENT WHERE TRUNC(TIME_ENTERED)=TRUNC(SYSDATE);
DELETE FROM LBR_CLR_APP_DECISION WHERE LBR_CLR_APP_ID=224379;
UPDATE LBR_CLR_APP SET APP_STATUS_ID=5 WHERE LBR_CLR_APP_ID=224379;
  
how to ensure we can focus the first array elem WPAMT[] in lbr_clr_app.js
document.getElementsByName("WPAMT[]")[0].focus();
(1) if status is APPROVED, automatically call gettblwptappudak() to load the array
(2) if status is not APPROVED, call gettblwptappudak() to load the array, when user changes decision to approve
*/
console.log("voucherwork props: "+JSON.stringify(props));

const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");
	
if (props.func=="gettblwptappudak")
	gettblwptappudak(props, setUdak, setDowait);
else if (props.func=="getprepinsertdoc")
	getprepinsertdoc(props, confirm, showsnackbar);
else if (props.func=="savechanges")
	savechanges(props, setUdak, setDowait);
else if (props.func=="clearwptappudak")
	clearwptappudak(props, setUdak, setDowait, setVchroptions);



async function getprepinsertdoc(props){

if (document.getElementById("tblsteps"))
	document.getElementById("tblsteps").scrollIntoView();
console.log("vchroptions.vchrtype: "+props.vchroptions.vchrtype);
const result=await confirm('payment vouchers will be created. proceed?');
if (!result)
	return;

document.getElementById('btinsertprepdoc').style.visibility='hidden';

let requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( props.params[0] )
};		
setDowait({show:true});
await fetch(resturl+'rarwpform/getprepinsertdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	insertprepdoc(res, props) )
  .catch(err => console.log(err));	

  
}//end func



	
async function insertprepdoc(res, props){
	
console.log('insertprepdoc res: '+JSON.stringify(res));

setDowait({show:false});

if (!res.length){
	showsnackbar("no records to send for voucher creation.<br/>please try again or contact admin.");
	return;
	}//end if
	
const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( res )
};		

setDowait({show:true});
await fetch(customspremurl+'rarwptapp/insertprepdoc',requestOptions)
  .then(res => res.json())
  .then(res => 	afterinsertprepdoc(res, props) )
  .catch(err => console.log(err));	
	
}//end func

async function afterinsertprepdoc(res, props){
	//console.log('afterinsertprepdoc'+JSON.stringify(res));
	setDowait({show:false});
	let tempdocs=[];
	for (var i=0; i<res.length; i++){
		/*send only data needed by rarwpform/updatedocno.  previously sent the entire res and sometimes glitched*/
		tempdocs.push({
				VCHR_TYPE:res[i].VCHR_TYPE
				,UDAK_NO:res[i].UDAK_NO
				,DOC_NO:res[i].DOC_NO
				,ENTRY_USER:res[i].ENTRY_USER
			});
		}//end for
	
	let params = props.params[1];
	params.docs=tempdocs;
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
setDowait({show:true});
 await fetch(resturl+'rarwpform/updatedocno',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatedocno(res, props) )
      .catch(err => console.log(err));	
	
}//end func

function afterupdatedocno(res, props){

	setDowait({show:false});
const BACK_PAGE=props.state.BACK_PAGE??"wptform";
if (document.getElementById("cbbalrcp")){
	document.getElementById("cbbalrcp").checked=true;
	document.getElementById("cbbalrcp").click();
	//tblvouchers
	}//end if
else	
	navigate("/"+BACK_PAGE, {state:props.state});

	
}//end func

async function gettblwptappudak(props, setUdak, setDowait){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( props.params[0] )
  };		

	setUdak([]);
	
await fetch(resturl+'rarwpform/gettblwptappudak',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptappudak(res, setUdak) )
      .catch(err => console.log(err));

}//end func

function aftergettblwptappudak(res, setUdak){
setDowait({show:false});
if (res.length==undefined)
	return;
//console.log('aftergettblwptappudak udak.length: '+udak.length);
setUdak(res);
}//end func



async function savechanges(props, setUdak, setDowait){

setDowait({show:true});
	setUdak([]);
	/*const APP_TYPE_ID=document.getElementsByName('APP_TYPE_ID')[0].value;*/

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( props.params[0] )
  };		

  await fetch(resturl+'rarwpform/updatewptappudak',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersavechanges(res, setUdak, setDowait) )
      .catch(err => console.log(err));	
	
}//end func

function aftersavechanges(res, setUdak, setDowait){
	aftergettblwptappudak(res, setUdak, setDowait);
	setDowait({show:false});
	if (document.getElementById('btnsavevchrchanges')){
		document.getElementById('btnsavevchrchanges').style.visibility='hidden';
		}//end if
	
	//setDowait({show:false});
	//gettblwptappudak();
	
}//end func



async function clearwptappudak(props, setUdak, setDowait, setVchroptions){

if (document.getElementById("tblsteps"))
	document.getElementById("tblsteps").scrollIntoView();

const result=await confirm('reset the table and start over?');	
if (!result)
	return;

//{VCHR_TYPE:"LC", WPT_APP_ID:wptapp.WPT_APP_ID, USERNAME:sessionStorage.getItem("USERNAME")}
const requestOptions = {
  method: 'POST'
  ,headers: { 'Content-Type': 'application/json' }
  ,body: JSON.stringify( props.params[0] )
};

setDowait({show:true});
setUdak([]);
await fetch(resturl+'rarwpform/clearwptappudak',requestOptions)
  .then(res => afterclearwptappudak(res, props, setUdak, setDowait, setVchroptions))
  .catch(err => console.log(err));

}//end func

function afterclearwptappudak(res, props, setUdak, setDowait, setVchroptions){
	setDowait({show:false});
	
	if (setVchroptions)
		setVchroptions((prev)=>{
			return {...prev, vchrtype:''}
		});
		
	if (document.getElementById('rdlcvchr')){
		document.getElementById('rdlcvchr').checked=false;
		document.getElementById('rdwpvchr').checked=false;
		}//end if
	gettblwptappudak(props, setUdak, setDowait);

}//end func
	
};


export default voucherwork;